import styled from '@emotion/styled';
import { Label, Paragraph, rem } from '@triumph/design-system';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(8)};
`;

export const Header = styled(Label)`
    margin: 0;
`;

export const NoMarginParagraph = styled(Paragraph)`
    margin: 0;
    font-size: ${rem(12)};
`;
